import React from "react";
import LoadingAni from "../../img/LoadingAni.gif";

const Loading = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed", // fixed position ensures full screen coverage
        top: 0,
        left: 0,
        width: "100vw", // full viewport width
        height: "100vh", // full viewport height
        zIndex: 1050, // ensure it's on top
        background: "rgba(152, 152, 152, 0.44)",
      }}
    >
      <div
        className="w-50 bg-white rounded shadow p-3 text-center"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <img
          src={LoadingAni}
          alt="Loading animation"
          style={{ width: "100px", marginBottom: "1rem" }}
        />
        <div className="progress" style={{ height: "1.5rem" }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
            style={{ width: "100%" }}
          >
            Loading...
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
